export enum Errors {
  INVALID_CREDENTIALS = 'Credenciais inválidas.',
  SOCIAL_TOKEN_NOT_INFORMED = 'Social token não informado.',
  SOCIAL_USER_NOT_ALLOWED = 'Usuário com rede social sem acesso ao sistema.',
  USER_NOT_ALLOWED = 'Usuário sem acesso ao sistema.',
  WORK_NOT_ALLOWED = 'Horário de expediente não permitido.',
  BLOCKED_USER = 'Usuário bloqueado.'
}
export function getErrorMessage(constant: string): string {
  return Errors[constant] || 'Erro inesperado.';
}
